export const ERROR_TYPE = {
  ORDER: 'order',
  ORDER_3DS: 'order_3ds',
  PREBUILD: 'prebuild',
} as const;
